module.exports = __webpack_public_path__ + "fonts/extrablack.68bddd9.woff2";